<template>
  <div id="loading">
    <div class="loader">
      <div class="square"></div>
      <div class="square"></div>
      <div class="square last"></div>
      <div class="square clear"></div>
      <div class="square"></div>
      <div class="square last"></div>
      <div class="square clear"></div>
      <div class="square "></div>
      <div class="square last"></div>
    </div>
    <p class="h3">loading your results</p>
  </div>
</template>

<style scoped>
  #loading {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    flex-direction: column;
    background-color: #fff;
    z-index: 100;
  }

  .loader {
    margin-bottom: 1rem;
  }

  p {
    color: hsla(220, 3%, 34%, 1);
  }
  
  @keyframes enter {
    0% { 
      opacity: 0;
      top: -10px;
    }
    5% { 
      opacity: 1;
      top: 0px;
    }
    50.9% { 
      opacity: 1;
      top: 0px;
    }
    55.9% { 
      opacity: 0;
      top: -10px;
    }
  }

  .square {
    background-color: #69bf4a;
    border: 2px solid transparent;
    width: 25px;
    height: 25px;
    float: left;
    top: -10px;
    margin-right: 5px;
    margin-top: 5px;
    position:relative;
    opacity: 0;
    -webkit-animation: enter 6s infinite;
    animation: enter 6s infinite;
    border-radius: 4px;
  }

  .enter {
    top: 0px;
    opacity: 1;
  }

  .square:nth-child(1) {
    animation-delay: 1.8s;
  }
  .square:nth-child(2) {
   animation-delay: 2.1s;
  }
  .square:nth-child(3) {
    animation-delay: 2.4s;
    background-color: #fff;
    border-color: #69bf4a;
  }
  .square:nth-child(4) {
    animation-delay: 0.9s;
  }
  .square:nth-child(5) {
    animation-delay: 1.2s;
  }
  .square:nth-child(6) {
    animation-delay: 1.5s;
  }

  .square:nth-child(8) {
    animation-delay: 0.3s;
  }
  .square:nth-child(9) {
    animation-delay: 0.6s;
  }
  .clear {
    clear: both;
  }
  
</style>